export enum DeliveryMethodQuoteCreationErrorCode {
  AddressNotCovered = 4725008,
  NoDriversAvailable = 4725009,
  ErrOrderValueTooLow = 472513,
}
